import { render } from "./SetTags.vue?vue&type=template&id=6c27ecb4&scoped=true"
import script from "./SetTags.vue?vue&type=script&lang=ts"
export * from "./SetTags.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6c27ecb4"

export default script